document.querySelectorAll("[href='#welcome-gift'").forEach(function(a){
  a.addEventListener("click", function(e){
    e.preventDefault();
    document.querySelector(".needsclick.kl-teaser-YdUFqU.undefined.kl-private-reset-css-Xuajs1").style.display = "block !important";
    document.querySelector(".needsclick.kl-teaser-YdUFqU.undefined.kl-private-reset-css-Xuajs1").click()
  })
})

class CustomSwiper {
    constructor(containerSelector, options = {}) {
        this.container = document.querySelector(containerSelector);
        if (!this.container) return; // Exit if container doesn't exist

        this.swiper = new Swiper(this.container, {
            loop: options.loop,
            autoplay: {
                delay: options.autoplayDelay || 3000,
                disableOnInteraction: options.disableOnInteraction || false,
            },
            pagination: {
                el: options.paginationSelector || '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: options.nextButtonSelector || '.swiper-button-next',
                prevEl: options.prevButtonSelector || '.swiper-button-prev',
            },
            slidesPerView: options.slidesPerView,
            spaceBetween: options.spaceBetween,
            breakpoints: options.breakpoints
        });
    }
}

function onload() {
    var swiper = new Swiper(".swiper-multicolumn-slider", {
        slidesPerView: 7,
        spaceBetween: 0,
        centeredSlides: false,
        loop: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        }
    });
}

document.addEventListener('DOMContentLoaded', function () {
    onload()
});

if (Shopify.designMode) {
    document.addEventListener('shopify:section:unload', onload);
    document.addEventListener('shopify:section:load', onload);
}

function customsliderprev(btn) {
    btn.parentElement.querySelector(".slider-button--prev").click()
}

function customslidernext(btn) {
    btn.parentElement.querySelector(".slider-button--next").click()
}

document.body.addEventListener("click", function (e) {
  const label = e.target.closest(".card-color-option .swatch-input__label");
  if (!label) return;

  e.preventDefault();
  label.previousElementSibling?.click();

  const mediaid = label.getAttribute("image-id");
  console.log('my media link is ' + mediaid);

  const allImages = label.closest(".product-card-wrapper")?.querySelectorAll(".media img");
  if (allImages?.length > 0) {
    allImages[0].src = mediaid;
    allImages[0].srcset = mediaid;
    allImages[0].classList.remove('hideme');
  }
});

document.body.addEventListener("mouseenter", function (e) {
  const label = e.target.closest(".card-color-option .swatch-input__label");
  if (!label) return;

  const mediaid = label.getAttribute("image-id");
  const allImages = label.closest(".product-card-wrapper")?.querySelectorAll(".media img");
  if (allImages?.length > 0) {
    allImages[0].src = mediaid;
    allImages[0].srcset = mediaid;
    allImages[0].classList.remove('hideme');
  }
}, true); // Use capture for mouseenter to trigger properly


document.querySelectorAll(".collection-title-group .title").forEach(function (header, index) {
    header.addEventListener("click", function () {
        this.parentElement.querySelector(".title.active").classList.remove("active");
        this.classList.add("active");
        document.querySelector(".collection-slider-all slider-component.active").classList.remove("active");
        document.querySelectorAll(".collection-slider-all slider-component")[index].classList.add("active");
      // we need to hide the existing view all button and show the proper index
      $('.collection__view-all').hide();
      $('.collection__view-all').eq(index).show();
    })
})

document.querySelectorAll(".footer-block__heading").forEach(function (block) {
    block.addEventListener("click", function () {
        this.classList.toggle("openfooter");
        var content = this.parentElement.querySelector(".footer-block__details-content");
        if (content) {
            content.classList.toggle("openfooter");
        }
    })
})

$(document).ready(function () {
$(document).on("click", 'a[href="/pages/schedule-virtual-stylist"]', function (e) {
    e.preventDefault();
    console.log("Navigation prevented!");

    setTimeout(() => {
        const popup = $(".scedule-stylist-popup");
        if (popup.length) {
            popup.addClass("showpopup");
            console.log("Popup shown!");
        } else {
            console.warn("Popup not found!");
        }
    }, 100);
});
});
 
$(document).on('click', 'a[href="#shopify-chat"]', function (e) {
  e.preventDefault();
setTimeout(() => {
    let chatWidget = document.querySelector('inbox-online-store-chat');
    
    if (chatWidget) {
        let shadowRoot = chatWidget.shadowRoot;
        if (shadowRoot) {
            let chatButton = shadowRoot.querySelector('button');
            if (chatButton) {
                console.log('Found chat button inside Shadow DOM, clicking...');
              $('#ShopifyChat').css('visibility','visible');
                chatButton.click();
            } else {
                console.log('Chat button not found inside Shadow DOM.');
            }
        } else {
            console.log('Shadow DOM not accessible.');
        }
    } else {
        console.log('Chat widget not found.');
    }
}, 500);

});


if (document.querySelector(".scedule-stylist-popup")) {
document.querySelector(".scedule-stylist-popup").addEventListener("click", function (event) {
    const popupContent = document.querySelector(".scedule-stylist-popup .grid .grid");
    if (popupContent && !popupContent.contains(event.target)) {
        document.querySelector(".scedule-stylist-popup").classList.remove("showpopup");
    }
});
}

$(document).ready(function () {
  if ($('.multicolumn.multicolumn-v4').length === 0) return;

  const MAX_TRIES = 30;
  let tries = 0;
  const poll = setInterval(() => {
    tries++;

    const container = document.querySelector('.multicolumn.multicolumn-v4 .brand-swiper');
    if (!container) {
      if (tries >= MAX_TRIES) {
        console.warn('brand-swiper container not found; giving up.');
        clearInterval(poll);
      }
      return;
    }

    const swiper = container.swiper; 
    if (!swiper || swiper.destroyed) { 
      if (tries >= MAX_TRIES) {
        console.warn('Swiper instance not ready; giving up.');
        clearInterval(poll);
      }
      return;
    }

    clearInterval(poll);
    console.log('Swiper ready:', swiper);

    // ---- Force Slide 3 safely (index 2) ----
    const total = swiper.slides ? swiper.slides.length : 0;
    if (total >= 3) {
      console.log('Forcing Slide 3…');
      if (swiper.params && swiper.params.loop) {
        swiper.slideToLoop(2, 500, true);
      } else {
        swiper.slideTo(2, 500, true);
      }
    } else {
      console.warn(`Only ${total} slides; skipping force.`);
    }
  }, 100);
});

document.addEventListener("DOMContentLoaded", function () {
  var anchors = document.querySelectorAll("a");

  anchors.forEach(function (a) {
    if (a.textContent.toLowerCase().includes("call")) {
      a.setAttribute("onclick", "return gtag_report_conversion('tel:833-393-4367');");
    }
  });
});

 